export default __webpack_public_path__ + "static/media/circle-chevron-left.8fc58b81.svg";